import axios from 'axios'

const baseURL = '/api/election/v1/'
export default {
  async apiauthen(body, googleResponseToken) {
    const axiosCreated = axios.create({
      baseURL,
      headers: {
        'x-recaptcha-response': googleResponseToken,
      },
    })

    return new Promise((resolve, reject) => {
      axiosCreated.post('abscause/auth/', body)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  async setInstance(token, flag, param, body) {
    const varient = (param) ? param.split('/') : ''
    const axiosInstance = axios.create({
      baseURL,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    switch (flag) {
      case 'get':
        return new Promise((resolve, reject) => {
          axiosInstance.get(`abscause/${varient[0]}/${varient[1]}`)
            .then((response) => {
              resolve(response.data)
            })
            .catch((error) => {
              reject(error)
            })
        })
      case 'insert':
        return new Promise((resolve, reject) => {
          axiosInstance.post('abscause/', body)
            .then((response) => {
              resolve(response.data)
            })
            .catch((error) => {
              reject(error)
            })
        })
      case 'update':
        return new Promise((resolve, reject) => {
          axiosInstance.put('abscause/', body)
            .then((response) => {
              resolve(response.data)
            })
            .catch((error) => {
              reject(error)
            })
        })
      case 'delete':
        return new Promise((resolve, reject) => {
          axiosInstance.delete(`abscause/${varient[0]}/${varient[1]}/${varient[2]}/${varient[3]}`)
            .then((response) => {
              resolve(response.data)
            })
            .catch((error) => {
              reject(error)
            })
        })
      default:
        break;
    }
  },
  async apiEledate(pid, laser, fname, lname, dob, googleResponseToken) {
    const body = {
      pid: Number(pid),
      fname,
      lname,
      dob: Number(dob),
      laser,
    }
    const result = await this.apiauthen(body, googleResponseToken)
    return result
  },
  async apiget(token, eletype, eledate) {
    const flag = 'get'
    const param = `${eletype}/${eledate}`
    const result = await this.setInstance(token, flag, param, null)
    return result
  },
  async apiinsert(token, data) {
    const flag = 'insert'
    const result = await this.setInstance(token, flag, null, data)
    return result
  },
  async apiupdate(token, data) {
    const flag = 'update'
    const result = await this.setInstance(token, flag, null, data)
    return result
  },
  async apidelete(token, eletype, eledate, mark2, cause) {
    const flag = 'delete'
    const param = `${eletype}/${eledate}/${mark2}/${cause}`
    const result = await this.setInstance(token, flag, param, null)
    return result
  },
}
